module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('div', {
    staticClass: "bb8-block-teaser"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.block.fields.title),
      expression: "block.fields.title"
    }],
    staticClass: "bb8-form-control bb8-block-teaser-title",
    attrs: {
      "placeholder": "Title",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.block.fields.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.block.fields.title = $event.target.value
      }
    }
  }), " ", _h('div', {
    staticClass: "bb8-block-teaser-content"
  }, [_h('div', {
    staticClass: "bb8-block-teaser-left"
  }, [_h('input', {
    staticClass: "bb8-block-teaser-image-fileinput",
    attrs: {
      "tabindex": "-1",
      "name": "image[file]",
      "type": "file",
      "accept": "image/*",
      "id": 'bb8-file-' + _vm.index
    },
    on: {
      "change": function($event) {
        _vm.updateImage($event)
      }
    }
  }), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.image == ''),
      expression: "block.fields.image == ''"
    }],
    staticClass: "bb8-block-teaser-image-label-wrapper"
  }, [_h('label', {
    staticClass: "bb8-block-teaser-image-label",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "for": 'bb8-file-' + _vm.index
    },
    on: {
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.target.click()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-upload"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-upload"
    }
  })])])]), " ", (_vm.block.fields.image != '') ? _h('div', {
    staticClass: "bb8-block-teaser-image-wrapper"
  }, [_h('div', {
    class: ['bb8-block-teaser-image-preview-wrapper', _vm.fields.alignment]
  }, [_h('img', {
    staticClass: "bb8-block-image-preview",
    attrs: {
      "src": _vm.block.fields.image
    }
  })]), " ", _h('a', {
    staticClass: "bb8-block-remove",
    on: {
      "click": function($event) {
        _vm.removeImage()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]) : _vm._e()]), " ", _h('div', {
    staticClass: "bb8-block-teaser-right"
  }, [_h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.block.fields.text),
      expression: "block.fields.text"
    }],
    staticClass: "bb8-form-control bb8-block-teaser-text",
    attrs: {
      "rows": "4",
      "placeholder": "Type your text",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.block.fields.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.block.fields.text = $event.target.value
      }
    }
  }), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.block.fields.link),
      expression: "block.fields.link"
    }],
    staticClass: "bb8-form-control",
    attrs: {
      "placeholder": "http://…"
    },
    domProps: {
      "value": _vm._s(_vm.block.fields.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.block.fields.link = $event.target.value
      }
    }
  })])]), " ", _h('a', {
    staticClass: "bb8-block-remove",
    on: {
      "click": function($event) {
        _vm.removeBlock()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-479ed84b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/TeaserBlock.vue
// module id = 44
// module chunks = 0